export enum LanguageType {
    //  Language Type Values: English(0), French(1)
    English = 'en',
    French = 'fr'
}
